export default "__VITE_ASSET__oHLgR_28__"